import { PropsWithChildren, forwardRef } from "react";
import { ScrollView, ScrollViewProps } from "react-native";

import { sizes, createStyles, ThemeSize } from "../theme";

export type ContentProps = ScrollViewProps &
  PropsWithChildren<{
    px?: ThemeSize;
    pt?: ThemeSize;
  }>;

export const Content = forwardRef<ScrollView, ContentProps>(
  ({ pt = "4", px = "4", style, ...rest }, ref) => {
    return (
      <ScrollView
        ref={ref}
        contentContainerStyle={[
          $.content,
          { paddingTop: sizes[pt] },
          { paddingHorizontal: sizes[px] },
          style,
        ]}
        keyboardShouldPersistTaps="handled"
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        {...rest}
      />
    );
  }
);

Content.displayName = "Content";

const $ = createStyles({
  content: {
    flexGrow: 1,
  },
});
